// extracted by mini-css-extract-plugin
module.exports = {"SpanStyles":"modal-remove-member_SpanStyles__10wA5"};